package com.essntl.features.qbauth.data.supabase

import com.essntl.features.qbauth.domain.model.QbAuthModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class QbAuthDto(
    val id: String,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("access_token")
    val accessToken: String?,
    @SerialName("refresh_token")
    val refreshToken: String?,
    @SerialName("expires_at")
    val expiresAt: String?,
    @SerialName("updated_at")
    val updatedAt: String?,
) {
    fun toModel() =
        QbAuthModel(
            id = id,
            createdAt = createdAt,
            accessToken = accessToken,
            refreshToken = refreshToken,
            expiresAt = expiresAt,
            updatedAt = updatedAt,
        )
}